import React, { useEffect, useState } from "react";
import { getAuthUser, updateProfile, changePassword } from "../../service/api";
import styles from "./index.module.css";
import ProfileForm from "./Profile.form";
import PasswordForm from "./Password.form";
import { showNotification } from "../../service/showNotification";
import { useAuth } from "../../context/AuthContext";

const Profile = () => {
  const { updateUserName } = useAuth();

  const [user, setUser] = useState(null);

  const fetchProfile = async () => {
    try {
      const res = await getAuthUser();
      setUser(res.data);
    } catch (err) {
      console.log("err", err);
    }
  };

  const handleProfileUpdate = async (data) => {
    try {
      const res = await updateProfile(data);
      updateUserName(res.data.name);
      setUser(res.data);
      showNotification(
        "success",
        res?.message || "Profile updated successfully"
      );
    } catch (error) {
      console.log("error", error);
      showNotification(
        "error",
        error?.response?.data?.message || "Failed to update profile"
      );
    }
  };

  const handlePasswordChange = async (data) => {
    try {
      const res = await changePassword(data);
      showNotification(
        "success",
        res?.message || "Password updated successfully"
      );
    } catch (error) {
      console.log("error", error);
      showNotification(
        "error",
        error?.response?.data?.message || "Failed to update password"
      );
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  if (!user) return <div className={styles.loading}>Loading...</div>;

  return (
    <div className={styles.profileContainer}>
      <div className={styles.profileCard}>
        {/* Header */}
        {/* <div className={styles.header}>
          <div className={styles.avatar}>
            {user.name?.charAt(0).toUpperCase()}
          </div>

          <div className={styles.userInfo}>
            <h1>{user.name}</h1>
            <p>{user.email}</p>
          </div>
        </div> */}
        {/* View Mode */}
        {/* {!editMode && !passwordMode && (
          <div className={styles.actionsGroup}>
            <Button
              className={styles.actionBtn}
              onClick={() => setEditMode(true)}
            >
              Edit Profile
            </Button>

            <Button
              variant="outline-primary"
              className={styles.actionBtnSecondary}
              onClick={() => setPasswordMode(true)}
            >
              Change Password
            </Button>
          </div>
        )} */}
        {/* <div className={styles.divider} /> */}

        <div className={styles.formHeading}>Profile</div>
        <ProfileForm user={user} onSubmit={handleProfileUpdate} />
      </div>
      <div className={styles.profileCard}>
        <div className={styles.formHeading}>Change Password</div>
        <PasswordForm onSubmit={handlePasswordChange} />
      </div>
    </div>
  );
};

export default Profile;
